import * as yup from 'yup'
import { INVALID_PRICE_FORMAT, REQUIRED_FIELD } from 'constants/errors'
import { priceReg } from 'constants/regExp'

export const schemaSendAchAuthorizationForm = yup.object().shape({
  bankAccountId: yup
    .mixed()
    .test('bankAccountId-required', REQUIRED_FIELD, (val) => val !== undefined && val !== null && val !== ''),
  amountOfTransaction: yup
    .string()
    .required(REQUIRED_FIELD)
    .matches(priceReg, INVALID_PRICE_FORMAT)
    .test('is-positive', 'Amount must be greater than zero', (val) => parseFloat(val || '0') > 0),
  achEffectiveDate: yup.date().nullable().required(REQUIRED_FIELD).typeError('MM/DD/YYYY'),
})
